import Vue from 'vue';
import Vuex from 'vuex';
import TokenManager from '@/utils/auth';

Vue.use(Vuex);

// 从 localStorage 恢复用户信息
const restoreUserInfo = () => {
  const userId = localStorage.getItem('userId');
  const username = localStorage.getItem('username');
  return {
    userId: userId || null,
    username: username || null
  };
};

export default new Vuex.Store({
  state: {
    userInfo: restoreUserInfo(),
    token: TokenManager.getToken()
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = { ...userInfo };
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    CLEAR_USER_INFO(state) {
      state.userInfo = {
        userId: null,
        username: null
      };
      state.token = null;
      TokenManager.clearToken();
    }
  },
  actions: {
    logout({ commit }) {
      commit('CLEAR_USER_INFO');
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    username: state => state.userInfo.username || TokenManager.getToken() ? localStorage.getItem('username') : null
  },
  modules: {
  }
});

